import { createAsyncThunk } from '@reduxjs/toolkit'
import { paginationData } from '../Pagination/reducers'
import * as service from './MemberShipReminder.services'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { fullName } from 'src/helpers/utils'

export const MembershipRevenueBreakDown = createAsyncThunk(
    '@Revenue-break-down/list',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await service.MembershipRevenueBreakDownApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                const limit = data?.params?._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data?.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (Number(data?.params?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            if (!err.response) {
                throw err
            }
            if (err.response.data) {
                // toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

// ClubListForRevenueBreakDownApi

export const ClubListForRevenueBreakDown = createAsyncThunk(
    '@Revenue-break-down/ClubList',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.ClubListForRevenueBreakDownApi()
            const finalRes = _.orderBy(
                _.map(res.data, (o) => {
                    return {
                        label: o.club_name,
                        value: o.club_id
                    }
                }),
                [(p) => _.lowerCase(p.label)],
                ['asc']
            )

            return finalRes
        } catch (err) {
            if (!err.response) {
                throw err
            }
            if (err.response.data) {
                toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const UserListByClubForRevenueBreakDown = createAsyncThunk(
    '@Revenue-break-down/UserListByClub',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.UserListByClubForRevenueBreakDownApi(data)
            const finalRes = _.orderBy(
                _.map(res.data, (o) => {
                    return {
                        label: fullName(o),
                        value: o.user_id
                    }
                }),
                [(p) => _.lowerCase(p.label)],
                ['asc']
            )

            return finalRes
        } catch (err) {
            if (!err.response) {
                throw err
            }
            if (err.response.data) {
                toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const RevenueBreakDownGrandTotal = createAsyncThunk(
    '@Revenue-break-down/GrandTotal',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.RevenueBreakDownGrandTotalApi(data)

            const finalRes = {
                grand_total: _.sumBy(res?.data, (o) => Number(o.grand_total || 0.0)).toFixed(2),
                connected_accnt_amt: _.sumBy(res?.data, (o) =>
                    Number(o?.connected_accnt_amt || 0.0)
                ).toFixed(2),
                master_accnt_amt: _.sumBy(res?.data, (o) =>
                    Number(o?.master_accnt_amt || 0.0)
                ).toFixed(2)
            }

            return finalRes
        } catch (err) {
            if (err.message) {
                toast.error(err.message)
            } else if (!err.response) {
                throw err
            }
            if (err.response.data) {
                toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)
